import { Injectable } from '@angular/core';
import { ProxyContext } from '@app/core/enums/proxy-context.enum';
import { HttpServerResponse } from '@app/core/models/response.model';
import { HttpRequestService } from '@app/core/services/http-request.service';
import { FileResponse } from '@app/shared/models/file-response.model';
import { Observable } from 'rxjs';
import { DownloadPaymentsDetailFileCommand } from '../command/download-payments-detail-file.command';
import { PayOdcManualCommand } from '../command/odc-tesoreria.command';
import { GetDetailODCStringCommand } from '../command/get-detail-odc-string.command';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(private readonly _httpRequestService: HttpRequestService) {}

  downloadPaymentsDetailFile(command: DownloadPaymentsDetailFileCommand): Observable<HttpServerResponse<FileResponse>> {
    return this._httpRequestService.post<FileResponse>(ProxyContext.DonwloadPaymentsDetailFile, command);
  }

  OdcPayment(command: PayOdcManualCommand): Observable<HttpServerResponse<FileResponse>> {
    return this._httpRequestService.post<FileResponse>(ProxyContext.ManualPaymant, command);
  }
  OdcPaymentDetail(command: GetDetailODCStringCommand): Observable<HttpServerResponse<FileResponse>> {
    return this._httpRequestService.post<FileResponse>(ProxyContext.DetailOdcSummary, command);
  }
}
